import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import * as Icon from "react-feather";
import "./SideMenu.css";
import { useSelector } from "react-redux";
import { ADMIN, RECEPTIONIST, STUDENT } from "../../../common/constants";
const SideMenuLight = (props) => {
  const { userDetails } = useSelector((state) => state.user);

  const renderSwitch = () => {
    switch (userDetails.role) {
      case ADMIN:
        return (
          <>
            <NavLink to="/addStudent" className="nav-link">
              <Icon.UserPlus className="icon" />
              <span className="title">Add Student</span>
            </NavLink>
            <NavLink to="/studentsList" className="nav-link">
              <Icon.Users className="icon" />
              <span className="title">Students </span>
            </NavLink>
            <NavLink to="/pendingRegistration" className="nav-link">
              <Icon.UserX className="icon" />
              <span className="title">Pending Registrations </span>
            </NavLink>
            <NavLink to="/paymentDue" className="nav-link">
              <Icon.User className="icon" />
              <span className="title">Payment Due</span>
            </NavLink>

            <NavLink to="/feeSetup" className="nav-link">
              <Icon.Inbox className="icon" />
              <span className="title">Fee Setup</span>
            </NavLink>
            <NavLink to="/notifications" className="nav-link">
              <Icon.Bell className="icon" />
              <span className="title">Notifications </span>
            </NavLink>
            <NavLink to="/paymentsList" className="nav-link">
              <Icon.CreditCard className="icon" />
              <span className="title">Payments List </span>
            </NavLink>
            <NavLink to="/reports" className="nav-link">
              <Icon.Database className="icon" />
              <span className="title">Reports </span>
            </NavLink>
            <NavLink to="/pendingPayments" className="nav-link">
              <Icon.Database className="icon" />
              <span className="title">Pending Payments </span>
            </NavLink>
          </>
        );
      case RECEPTIONIST:
        return (
          <>
            <NavLink to="/addStudent" className="nav-link">
              <Icon.UserPlus className="icon" />
              <span className="title">Add Student</span>
            </NavLink>
            <NavLink to="/studentsList" className="nav-link">
              <Icon.Users className="icon" />
              <span className="title">Students </span>
            </NavLink>
            <NavLink to="/pendingRegistration" className="nav-link">
              <Icon.UserX className="icon" />
              <span className="title">Pending Registrations </span>
            </NavLink>
            <NavLink to="/paymentDue" className="nav-link">
              <Icon.User className="icon" />
              <span className="title">Payment Due</span>
            </NavLink>
            <NavLink to="/notifications" className="nav-link">
              <Icon.Bell className="icon" />
              <span className="title">Notifications </span>
            </NavLink>
            {/* <NavLink to="/paymentsList" className="nav-link">
                  <Icon.CreditCard className="icon" />
                  <span className="title">Payments List </span>
                </NavLink> */}
            <NavLink to="/pendingPayments" className="nav-link">
              <Icon.Database className="icon" />
              <span className="title">Pending Payments </span>
            </NavLink>
          </>
        );
      case STUDENT:
        return (
          <>
            <NavLink to="/student/paymentsList" className="nav-link">
              <Icon.CreditCard className="icon" />
              <span className="title">Payments List </span>
            </NavLink>
            <NavLink to="/student/notifications" className="nav-link">
              <Icon.Bell className="icon" />
              <span className="title">Notifications </span>
            </NavLink>
            <NavLink to="/student/resetPassword" className="nav-link">
              <Icon.Bell className="icon" />
              <span className="title">Reset Password </span>
            </NavLink>
          </>
        );
      default:
        return "";
    }
  };

  return (
    <div
      className={`sidemenu-area sidemenu-light ${
        props.sideMenu ? "sidemenu-toggle" : ""
      }`}
    >
      <Navbar className={`sidemenu ${props.sideMenu ? "hide-nav-title" : ""}`}>
        <Navbar.Collapse>
          <Nav>
            <NavLink to="/dashboard" className="nav-link">
              <i className="fa fa-tachometer icon"></i>
              <span className="title">Dashboard</span>
            </NavLink>
            {renderSwitch()}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default SideMenuLight;
